import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Typography, Hidden } from '@material-ui/core'
import { useStyles } from '../SchoolShow_style'
import ExpandingText from 'components/ExpandingText/ExpandingText'
import SchoolSocialLinks from './SchoolSocialLinks'
import SchoolMoreInfoButton from './SchoolMoreInfoButton'
import ShowPageTabs from 'components/ShowPageTabs/ShowPageTabs'
import { Image, Transformation } from 'cloudinary-react'

const SchoolPassport = (props) => {
    const { school, selectedTab, tabs, setTab } = props
    const classes = useStyles()

    return (
        <>
            <Typography variant='h1' component='h2' className={classes.schoolTitle}>
                <FormattedMessage id='job_show.company_info_card.title_prefix' /> {school.name}
            </Typography>
            {school.paid &&
                <Hidden smDown>
                    <SchoolSocialLinks school={school}/>
                </Hidden>
            }
            <Hidden mdUp>
                <Box className={classes.tabBox}>
                    <ShowPageTabs
                        tabs={tabs}
                        selectedTab={selectedTab}
                        setTab={setTab}
                    />
                </Box>
            </Hidden>
            {selectedTab === 'overview' &&
                <Box className={classes.passportSchoolDescription}>
                    <ExpandingText text={school.description} />
                </Box>
            }
            {['faculties', 'featured_campuses'].includes(selectedTab) &&
                <Hidden smDown>
                    <Box className={classes.passportSchoolDescription}>
                        <ExpandingText text={school.description} />
                    </Box>
                </Hidden>
            }
            {school.paid && school.url &&
                <Hidden smDown>
                    <SchoolMoreInfoButton school={school}/>
                </Hidden>
            }
            {school.paid && selectedTab === 'overview' &&
                <Box className={classes.ctaBox}>
                    <Typography variant='h1' component='span' className={classes.blurbDescription}>
                        {school.blurb_description}
                    </Typography>
                    <Typography component='span'>
                        {school.blurb_title}
                    </Typography>
                </Box>
            }
            {school.paid && selectedTab === 'featured_campuses' && school.campus_map_image &&
                <Box className={classes.campusImageBox}>
                    <Image
                        cloudName='studentbe'
                        publicId={school.campus_map_image.cloudinary_key}
                        alt='student.be publish a student job fast'
                        className={classes.campusImage}
                    >
                        <Transformation flags='progressive' fetchFormat='auto' quality='auto:best' width={600} crop='fill' />
                    </Image>
                </Box>
            }
        </>
    )
}

export default SchoolPassport
